import { render, staticRenderFns } from "./OnboardingSection.vue?vue&type=template&id=08cebd02&scoped=true"
import script from "./OnboardingSection.vue?vue&type=script&lang=js"
export * from "./OnboardingSection.vue?vue&type=script&lang=js"
import style0 from "./OnboardingSection.vue?vue&type=style&index=0&id=08cebd02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cebd02",
  null
  
)

export default component.exports